import React from 'react';

import classnames from 'classnames';

import { Text, TextType } from 'ui-components/components/text';

import { useEnableMultiPackageShipmentsOrderDetails } from '../../../../feature-flags/hooks/use-multi-package-shipping-order-details';

import style from './fields.module.less';
import sharedFieldStyle from '../../shared-field-labels/form-fields.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode} [props.children]
 * @param {string}[ props.label]
 * @param {string} [props.labelId]
 * @param {string} [props.labelFor]
 * @param {React.ReactNode} [props.button]
 * @param {boolean} [props.hasValidationError]
 * @returns {React.ReactNode}
 */
const LabeledField = ({ children = null, label = '', labelId = '', labelFor = '', button = null, hasValidationError = false }) => {
  const enableMultiPackageShipmentsOrderDetails = useEnableMultiPackageShipmentsOrderDetails();

  // TODO: use this version when the feature flag is removed
  if (enableMultiPackageShipmentsOrderDetails) {
    return (
      <div className={sharedFieldStyle.field}>
        <Text
          className={classnames(sharedFieldStyle['field-label'], {
            [style['validation-error']]: hasValidationError,
          })}
          htmlFor={labelFor}
          id={labelId}
          textType={TextType.Label}
          value={label}
        />
        {children}
      </div>
    );
  }

  return (
    <div className={sharedFieldStyle.field}>
      <Text
        className={classnames(sharedFieldStyle['field-label'], {
          [style['validation-error']]: hasValidationError,
        })}
        htmlFor={labelFor}
        id={labelId}
        textType={TextType.Label}
        value={label}
      />
      <div className={style['field-content']}>
        {children}
        {button && <div className={style['field-button-container']}>{button}</div>}
      </div>
    </div>
  );
};

export default LabeledField;
